<div class="card4 p-1 mx-1  ">

    <div class="p-1">
        <div class="text-xs text-gray-500 size15">TVA</div>
        <div class="text-sm font-medium size24">{{productData.tva?.valeur}} %</div>

    </div>
</div>
